import handler from '../handler/handler';
import messages from '../handler/messages/messages';

const statusHandler = handler(messages);

export default {
  state: {
    list: [],
  },
  getters: {
    getWineryList: state => state.list,
  },
  mutations: {
    successWineries: (state, payload) => {
      state.list = payload;
    },
  },
  actions: {
    getWineryList: async ({ commit, getters }) => {
      const result = await statusHandler.authGet({ commit, getters }, '/api/wineries/');

      commit('successWineries', result.response.result.rows);
      return result.response.result.rows;
    },

    updateWinery: async ({ commit, getters }, data) => {
      const winery = {
        id: data.id,
        name: data.name,
        name_en: data.nameEn,
        regions: null,
        latitude: data.latitude,
        longitude: data.longitude,
        mapZoom: data.mapZoom,
        isChecked: data.isChecked,
      };

      const result = await statusHandler.authPut({ commit, getters }, `/api/wineries/${winery.id}`, winery);
      return result;
    },

    createEmptyWinery: async ({ commit, getters }) => {
      const result = await statusHandler.authPost({ commit, getters }, '/api/wineries');
      return result;
    },

    deleteWinery: async ({ commit, getters }, id) => {
      const result = await statusHandler.authDelete({ commit, getters }, `/api/wineries/${id}`);
      return result;
    },

    deleteWineries: async ({ commit, getters }, ids) => {
      const result = await statusHandler.authPatch({ commit, getters }, '/api/wineries/delete', ids);
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/winery.js